// extracted by mini-css-extract-plugin
module.exports = {"label":"Input_label__aDlQF","feedback":"Input_feedback__zVVA_","hint":"Input_hint__Wugoq","infoPrompt":"Input_infoPrompt__RA5A1"};